var slider_chevron_right = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
	<path style="fill:currentColor" d="M388.819,239.537L156.092,6.816c-9.087-9.089-23.824-9.089-32.912,0.002
	c-9.087,9.089-9.087,23.824,0.002,32.912l216.27,216.266L123.179,472.272c-9.087,9.089-9.087,23.824,0.002,32.912
	c4.543,4.544,10.499,6.816,16.455,6.816c5.956,0,11.913-2.271,16.457-6.817L388.819,272.45c4.366-4.364,6.817-10.283,6.817-16.455
	C395.636,249.822,393.185,243.902,388.819,239.537z"/>
</svg>`;
var slider_chevron_left = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
	<path style="fill:currentColor" d="M172.548,256.005L388.82,39.729c9.089-9.089,9.089-23.824,0-32.912s-23.824-9.089-32.912,0.002
	L123.18,239.551c-4.366,4.363-6.817,10.282-6.817,16.454c0,6.173,2.453,12.093,6.817,16.457l232.727,232.721
	c4.543,4.544,10.499,6.816,16.455,6.816s11.913-2.271,16.457-6.817c9.089-9.089,9.089-23.824,0-32.912L172.548,256.005z"/>
</svg>`;

if ($(".more-starp-sl").length) {
	var $slider6 = $(".more-starp-sl").on("init", function(e) {
			$(".more-starp-sl").fadeIn(1e3)
	}).slick({
			infinite: !0,
			slidesToShow: 4,
			slidesToScroll: 4,
			dots: true,
			lazyLoad: "ondemand",
			responsive: [{
					breakpoint: 992,
					settings: {
							slidesToShow: 3,
							slidesToScroll: 3
					}
			}, {
					breakpoint: 580,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}, {
					breakpoint: 480,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}]
	});
} 
if ($(".product__slider-main").length) {
	$slider1 = $(".list_sil").on("init", function(e) {
			$(".list_sil").fadeIn(1e3)
	}).slick({
			infinite: !0,
			slidesToShow: 2,
			slidesToScroll: 2,
			dots: true,
			centerPadding: '5px',
			lazyLoad: "ondemand",
			prevArrow: '<button type="button" class="slick-prev">Previous' + slider_chevron_left + '</button>',
			nextArrow: '<button type="button" class="slick-next">Next' + slider_chevron_right + '</button>',
			responsive: [{
					breakpoint: 769,
					settings: {
							slidesToShow: 3,
							slidesToScroll: 3
					}
			}, {
					breakpoint: 580,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}, {
					breakpoint: 480,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}]
	}),
	$slider5 = $(".list_gld").on("init", function(e) {
			$(".list_gld").fadeIn(1e3)
	}).slick({
			infinite: !0,
			dots: true,
			slidesToShow: 2,
			slidesToScroll: 2,
			margin: 10,
			lazyLoad: "ondemand",
			prevArrow: '<button type="button" class="slick-prev">Previous' + slider_chevron_left + '</button>',
			nextArrow: '<button type="button" class="slick-next">Next' + slider_chevron_right + '</button>',
			responsive: [{
					breakpoint: 769,
					settings: {
							slidesToShow: 3,
							slidesToScroll: 3
					}
			}, {
					breakpoint: 580,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}, {
					breakpoint: 480,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}]
	}),
	$slider3 = $(".list_blk").on("init", function(e) {
			$(".list_blk").fadeIn(1e3)
	}).slick({
			infinite: !0,
			slidesToShow: 2,
			dots: true,
			slidesToScroll: 2,
			lazyLoad: "ondemand",
			prevArrow: '<button type="button" class="slick-prev">Previous' + slider_chevron_left + '</button>',
			nextArrow: '<button type="button" class="slick-next">Next' + slider_chevron_right + '</button>',
			responsive: [{
					breakpoint: 769,
					settings: {
							slidesToShow: 3,
							slidesToScroll: 3
					}
			}, {
					breakpoint: 580,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}, {
					breakpoint: 480,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}]
	});
	$slider4 = $(".list_rose-gld").on("init", function(e) {
			$(".list_rose-gld").fadeIn(1e3)
	}).slick({
			infinite: !0,
			slidesToShow: 2,
			dots: true,
			slidesToScroll: 2,
			lazyLoad: "ondemand",
			prevArrow: '<button type="button" class="slick-prev">Previous' + slider_chevron_left + '</button>',
			nextArrow: '<button type="button" class="slick-next">Next' + slider_chevron_right + '</button>',
			responsive: [{
					breakpoint: 769,
					settings: {
							slidesToShow: 3,
							slidesToScroll: 3
					}
			}, {
					breakpoint: 580,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}, {
					breakpoint: 480,
					settings: {
							slidesToShow: 2,
							slidesToScroll: 2
					}
			}]
	});
}

//added

  $(document).ready(function() {
    $("body").on("click", "#sil-btn", function() {
				$("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_gld").removeClass("hide-me"), $(".list_blk").removeClass("hide-me"), $(".list_rose-gld").removeClass("hide-me"),$(".list_sil").toggleClass("hide-me")
		}), $("body").on("click", "#gld-btn", function() {
				$("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_sil").removeClass("hide-me"), $(".list_blk").removeClass("hide-me"), $(".list_rose-gld").removeClass("hide-me"),$(".list_gld").toggleClass("hide-me")
		}), $("body").on("click", "#blk-btn", function() {
				$("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_sil").removeClass("hide-me"), $(".list_gld").removeClass("hide-me"),$(".list_rose-gld").removeClass("hide-me"), $(".list_blk").toggleClass("hide-me")
		}), $("body").on("click", "#rose-gld-btn", function() {
				$("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_sil").removeClass("hide-me"), $(".list_gld").removeClass("hide-me"),$(".list_blk").removeClass("hide-me"), $(".list_rose-gld").toggleClass("hide-me")
		}),

		$("body").on("click", ".my-additional-btn", function() {
				var e = $(this).data("vrnt");
				data = {
						quantity: 1,
						id: e
				}, jQuery.ajax({
						type: "POST",
						url: "/cart/add.js",
						data: data,
						dataType: "json",
						success: function() {
								window.location.href = "/cart"
						}

				})
		})
});

$('.color-slider-click.clk, .color-slider-click.ckl').click(function(){
	product_item = $(this).parents('[data-product-item]');
	if($(this).hasClass('clk')) {
		$(this).addClass('active').siblings().removeClass('active');
	} else {
		$(this).addClass('active1').siblings().removeClass('active1');
	}

	var xttext1 = product_item.find('.active').text();
	var xtext = product_item.find('.active1').text();

	var txt2 = xttext1 +" / "+ xtext;

	console.log(txt2);
	product_item.find('select.slider--col option').each(function(){
		var txt = $(this).text();
		if(txt.indexOf(txt2) != -1){
			var variant_id =  $(this).val();
			var stck = $(this).data('stock');
			var price = $(this).data('price');
			var compare_at_price = $(this).data('compare-at-price');

			product_item.find('.my-additional-btn').attr('data-vrnt', variant_id);
		  product_item.find('input.check--color').val(variant_id);
		  //console.log(stck);
			if(stck){
				if(stck.indexOf('deny') != -1){
					product_item.find('.my-additional-btn').text('Sold Out').css('pointer-events', 'none') ;
				}else{
					product_item.find('.my-additional-btn').text('ADD TO CART').css('pointer-events', '') ;
				}
			}


			$(this).parent().val(variant_id);
			product_item.find('[data-current-variant-price]').html(price);
			compare_at_price ? product_item.find('[data-current-variant-compare-at-price]').html(compare_at_price).show() : product_item.find('[data-current-variant-compare-at-price]').hide();

			var chkq = $(this).data('policy');
			if(chkq){
				if(chkq.indexOf('deny') != -1){
					if(product_item.find('input.check--color').prop("checked") == true){
						product_item.find('input.check--color').trigger('click');
					}
					product_item.find('input.check--color').attr('disabled', 'true');
				}else{
					product_item.find('input.check--color').removeAttr('disabled');
				}
			}
		}
	});
});

$('a.color-clik').click(function(e){
	e.preventDefault();
	var input = $(this).parent().find('input.check--color');
	input.trigger('click');
});

$('.check--color').on('change', function(){
	$(this).parents('.my-slidercolor').toggleClass('selected');
});
$('span.color-slider-click.iphon').click(function(){
  $(this).parent().find('span.color-slider-click').removeClass('active1');
$(this).addClass('active1');
var vtid = $(this).data('idv');
  // console.log(vtid);
  $(this).parent().parent().find('.my-additional-btn').attr('data-vrnt', vtid);
 $(this).parent().parent().find('input.check--color').val(vtid);
});

  $('span.size--gide-main').click(function(){
$('.abu').show();
});
$('.ab-close').click(function(){
$('.abu').hide();
  $('.abu-ques').hide();
});

$('.list-0 span.qusmark').click(function(){
$('.abu-ques').show();
});